import { useEffect, useState } from 'react'

export const useDraggable = <T>(
  initialItems: T[],
  onReorder?: (items: T[]) => void,
) => {
  const [orderedItems, setOrderedItems] = useState<T[]>(initialItems)
  const [dragIndex, setDragIndex] = useState<number | null>(null)
  const [overIndex, setOverIndex] = useState<number | null>(null)

  useEffect(() => {
    setOrderedItems(initialItems)
  }, [initialItems])

  const handleDragStart = (index: number) => setDragIndex(index)

  const handleDragOver = (index: number) => {
    if (dragIndex === null || dragIndex === index) return
    setOverIndex(index)
  }

  const handleDragEnd = () => {
    if (dragIndex !== null && overIndex !== null && dragIndex !== overIndex) {
      setOrderedItems((prev) => {
        const next = [...prev]
        const [moved] = next.splice(dragIndex, 1)
        next.splice(overIndex, 0, moved)
        onReorder?.(next)
        return next
      })
    }
    setDragIndex(null)
    setOverIndex(null)
  }

  return {
    orderedItems,
    dragIndex,
    overIndex,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
  }
}
